/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from '../StudentRouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.state-reporting.pims'},
});

const PimsItem = () => (
  <StudentRouteLinkItem
    route="midas/student/state-reporting/pims"
    title={messages.title}
  />
);

export default PimsItem;
